/**
 * Système de tooltip moderne pour Master League
 * Utilise Alpine.js pour la gestion des tooltips stylisés
 */

document.addEventListener('alpine:init', () => {
    Alpine.data('tooltip', () => ({
        show: false,
        content: '',
        position: { x: 0, y: 0 },
        placement: 'top', // top, bottom, left, right
        activeElement: null, // élément actuellement affiché (mobile : tap-to-toggle)
        touchHideTimer: null,

        init() {
            // Écouter les événements sur tous les éléments avec data-tooltip
            this.$nextTick(() => {
                this.initTooltips();
            });

            // Mobile : masquer le tooltip si on tape ailleurs qu'un élément [data-tooltip]
            document.addEventListener('touchstart', (e) => {
                if (this.show && !e.target.closest('[data-tooltip]')) {
                    this.hideTooltip();
                }
            }, { passive: true });
        },

        initTooltips() {
            const tooltipElements = document.querySelectorAll('[data-tooltip]:not([data-tooltip-bound])');

            tooltipElements.forEach(element => {
                element.setAttribute('data-tooltip-bound', '1');

                // Desktop: mouseenter/mouseleave
                element.addEventListener('mouseenter', () => {
                    this.showTooltip(element);
                });

                element.addEventListener('mouseleave', () => {
                    this.hideTooltip();
                });

                // Mobile: tap-to-toggle (plus découvrable que l'appui long,
                // et évite le conflit avec le long-press natif / menu contextuel).
                let touchMoved = false;

                element.addEventListener('touchstart', () => {
                    touchMoved = false;
                }, { passive: true });

                element.addEventListener('touchmove', () => {
                    touchMoved = true;
                }, { passive: true });

                element.addEventListener('touchend', (e) => {
                    if (touchMoved) return; // c'était un scroll, pas un tap

                    // Élément actionnable (lien, bouton, @click) : ne PAS avaler le tap,
                    // sinon la navigation/l'action ne se déclenche jamais sur mobile (#334).
                    // On laisse le clic natif se produire ; le tooltip reste dispo au survol desktop.
                    if (this.isActionable(element)) return;

                    e.preventDefault(); // évite le ghost-click et le callout natif

                    // Si déjà affiché pour cet élément → on masque (toggle)
                    if (this.show && this.activeElement === element) {
                        this.hideTooltip();
                        return;
                    }

                    this.showTooltip(element);
                    clearTimeout(this.touchHideTimer);
                    this.touchHideTimer = setTimeout(() => {
                        this.hideTooltip();
                    }, 3000); // auto-masquage après 3s
                });
            });
        },

        // Un élément est "actionnable" si taper dessus doit déclencher une navigation
        // ou une action (lien, bouton, handler @click/onclick, role=button).
        isActionable(element) {
            if (element.matches('a[href], button, [role="button"], [onclick]')) {
                return true;
            }
            // Handlers Alpine (@click / x-on:click) posés directement sur l'élément
            return element.hasAttribute('@click')
                || element.hasAttribute('x-on:click')
                || element.hasAttribute('@click.prevent')
                || element.hasAttribute('x-on:click.prevent');
        },

        showTooltip(element) {
            const tooltipText = element.getAttribute('data-tooltip');
            const placement = element.getAttribute('data-tooltip-placement') || 'top';

            if (!tooltipText) return;

            this.content = tooltipText;
            this.placement = placement;
            this.activeElement = element;
            this.calculatePosition(element);
            this.show = true;
        },

        hideTooltip() {
            this.show = false;
            this.activeElement = null;
            clearTimeout(this.touchHideTimer);
        },
        
        calculatePosition(element) {
            const rect = element.getBoundingClientRect();
            const offset = 10; // Espacement entre l'élément et le tooltip
            
            // Position initiale au centre de l'élément
            let x = rect.left + (rect.width / 2);
            let y;
            
            switch (this.placement) {
                case 'top':
                    y = rect.top - offset;
                    break;
                    
                case 'bottom':
                    y = rect.bottom + offset;
                    break;
                    
                case 'left':
                    x = rect.left - offset;
                    y = rect.top + (rect.height / 2);
                    break;
                    
                case 'right':
                    x = rect.right + offset;
                    y = rect.top + (rect.height / 2);
                    break;
                    
                default:
                    y = rect.top - offset;
            }
            
            this.position = { x, y };
        },
        
        getTooltipStyle() {
            return `left: ${this.position.x}px; top: ${this.position.y}px;`;
        },
        
        getArrowClass() {
            return `tooltip-arrow-${this.placement}`;
        }
    }));
});

// Initialiser le système de tooltip au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
    // Observer les changements dans le DOM pour initialiser les nouveaux tooltips
    const observer = new MutationObserver(() => {
        const tooltipComponent = Alpine.$data(document.querySelector('[x-data*="tooltip"]'));
        if (tooltipComponent) {
            tooltipComponent.initTooltips();
        }
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
